import * as React from "react";
import cn from "classnames";
import Styles from "../../Icon/Icon.module.scss";
import { IconProps, IconSizes } from "../icon-prop-types";

export const ChevronIcon = ({ fill = "black", size = "xsmall" }: IconProps) => {
  const fillStyles = cn(Styles[fill], Styles.fill);
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox={`0 0 14 14`}
    >
      <path
        className={fillStyles}
        d="M1.079 13c-.277 0-.553-.106-.763-.317-.421-.424-.421-1.109 0-1.532L4.949 6.5.316 1.848C-.105 1.426-.105.741.316.318c.421-.424 1.104-.424 1.526 0L8 6.5l-6.158 6.183c-.21.21-.487.317-.763.317"
        fillRule="evenodd"
      />
    </svg>
  );
};
